import React from 'react';
import PackageInformations from '../../utils/tabs/packageInformations/PackageInformations';
/**
 * Affiche le composant d'information sur le colis dans le drawer
 * de la section colis prêt
 */
const PackageInformationsTab = () => (
  <div>
    <PackageInformations />
  </div>
);

export default PackageInformationsTab;
